import { getCookie } from 'owa-service/lib/universalCookies';

export function getUserToptOutCookie(): boolean {
    // The meaning of the TOptOut value
    // "" - user has all targeting on
    // "1" - user has no targeting on this browser
    // "2" - user has targeting on this browser but not on his live account
    // "3" - user has no targeting on this browser on his live account
    return !!getCookie('TOptOut');
}
